import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  credentialId: '',
  resource: 'company',
  action: 'getCompanyList',
  companyId: '',
  teamMemberId: '',
  teamMemberData: '',
  periodId: '',
  paymentId: '',
  webhookId: '',
  taxYear: '',
  url: '',
  events: [],
  secret: '',
  format: 'json',
  page: 1,
  pageSize: 25,
};

export default defaults;
